import { useLayoutEffect } from 'react';
import { TOPBAR } from '../appTemplate.consts';

export const useTopBarBottomVar = (topSlotHeight: number) => {
  useLayoutEffect(() => {
    const { style } = document.documentElement;
    style.setProperty(TOPBAR.bottomCssVar, `${topSlotHeight + TOPBAR.height}px`);

    return () => {
      style.removeProperty(TOPBAR.bottomCssVar);
    };
  }, [topSlotHeight]);
};
